<template>
  <div class="tooltip-buttons">
    <button @click="openHammerTooltip" title="Add Hammer Tooltip">
      <img width="20" src="/images/icon/hammer.svg" alt="Hammer Tooltip" />
    </button>
    <button @click="openCircleTooltip" title="Add Circle Tooltip">
      <img width="20" src="/images/icon/circle.svg" alt="Circle Tooltip" />
    </button>
    <button @click="openLightTooltip" title="Add Light Tooltip">
      <img width="20" src="/images/icon/lightbulb.svg" alt="Light Tooltip" />
    </button>
  </div>
</template>

<script setup>
import { defineProps, defineEmits } from "vue";

defineProps({
  editor: {
    type: Object,
    required: true,
  },
});

const emit = defineEmits(["open-tooltip-modal"]);

const openHammerTooltip = () => {
  emit("open-tooltip-modal", "hammer");
};

const openCircleTooltip = () => {
  emit("open-tooltip-modal", "circle");
};

const openLightTooltip = () => {
  emit("open-tooltip-modal", "light");
};
</script>

<style scoped>
.tooltip-buttons {
  display: flex;
  gap: 10px;
}

.tooltip-buttons button img {
  width: 16px;
  height: 16px;
  filter: brightness(0);
}
</style>
